import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: [
    './pages.component.scss'  
    ],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class PagesComponent implements OnInit {

  private sub: any;

  page:any;

  constructor(public api:ApiService, private route: ActivatedRoute, private router: Router, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.sub = this.route.params.subscribe(params => {
      let url = params['url'].split(/[\?\%]+/);
      if (url[0] === 'jouer-distribuer-agir-notre-bilan-rse-2025') {
        this.router.navigate(['/bilan-rse']);
        return;
      }
      forkJoin([
        this.api.getJson("https://wordpress.blackrockgames.fr/wp-json/wp/v2/pages?slug="+url[0]),
        this.api.getJson("https://wordpress.blackrockgames.fr/wp-json/wp/v2/posts?slug="+url[0])
      ]).subscribe(([page, post]:any) => {
        let res = page && page[0] ? page : post && post[0] ? post : null;
        if(res && res[0]){
          let html = "<style>";
          if(res[0].css){
            for(let c of res[0].css){
              html += c;
            }
          }
          html += "</style>"+res[0].content.rendered;
          res[0].html = this.sanitizer.bypassSecurityTrustHtml(html);
          this.page = res[0];
        }else{
          this.page = {
            html: "Cette page n'existe pas"
          }
        }
      })
    });
  }



  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
